export const company = {
  legalName: 'Bliss Building Contractors Ltd',
  shortName: 'Bliss Building Contractors',
  tagline: 'From ground works to complete roof replacements',
  description:
    'Local contracting specialists serving London, Essex and Suffolk. Roofing, driveways, landscaping, damp proofing and spray foam removal.',
  phone: '0800 288 8007',
  phoneTel: '+448002888007',
  mobile: '07982 302235',
  mobileTel: '+447982302235',
  whatsappTel: '447982302235',
  email: 'BlissbuildingcontractorsLtd@gmail.com',
  hub: 'Braintree, Essex',
  /** Headline regions used in copy and JSON-LD areaServed. */
  areasServed: ['London', 'Essex', 'Suffolk'],
  /** Town-level coverage shown as chips - good for local SEO. */
  serviceTowns: [
    'Braintree',
    'Chelmsford',
    'Colchester',
    'Basildon',
    'Ilford',
    'Tilbury',
    'Loughton',
    'Clacton-on-Sea',
    'Ipswich',
    'Bury St Edmunds',
  ],
  serviceCoverage: 'London, Essex, Suffolk and the surrounding areas',
  hours: 'Mon to Sat 08:00 to 18:00. 24/7 emergency roof callouts.',
  url: 'https://blissbuildingcontractorsltd.co.uk',
  guarantees: [
    'Free surveys and quotes',
    'No call-out charges',
    'All work guaranteed',
    'Fully insured',
    'Free help and advice',
  ],
  socials: {
    facebook: 'https://www.facebook.com/people/Bliss-Building-Contractors-Ltd/61586281411385/',
    twitter: 'https://x.com/blissbuild26715',
    tiktok: 'https://www.tiktok.com/@blissbuildingcontractors',
  },
  google: {
    placeId: 'ChIJN6aDbwDx2EcR6RRxQcIyzM0',
    /** Google review write URL deep-link, built from the place ID. */
    reviewUrl: 'https://search.google.com/local/writereview?placeid=ChIJN6aDbwDx2EcR6RRxQcIyzM0',
  },
} as const;
